// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"02c0c3fe","94":"63457f05","620":"d483f59c","629":"7547ad30","835":"93c3d38e"}[chunkId] + ".chunk.css";
};